import moment from 'moment';
import { setFilteredAdverts } from '../actions';

export default function filterAdverts() {
  return (dispatch, getState) => {
    const { adverts: advertsState, advertsFilters } = getState();
    const { adverts } = advertsState;
    const { departure, month, travelLength } = advertsFilters;

    const filteredAdverts =
      adverts &&
      adverts.filter((advert) => {
        if (departure.value) {
          if (departure.value.value !== advert.airport.code) {
            return false;
          }
        }

        if (month.value) {
          const advertMonth = moment(advert.dates.from).format('MM');
          if (month.value.value !== advertMonth) {
            return false;
          }
        }

        if (travelLength.value) {
          const [min, max] = travelLength.value.value;
          if (advert.dates.days < min || advert.dates.days > max) {
            return false;
          }
        }

        return true;
      });

    adverts && dispatch(setFilteredAdverts(filteredAdverts));
  };
}
